import styled from '@emotion/styled'
import { useForm } from 'react-hook-form'

import Button from 'components/Button'
import Form from 'components/fields/Form'
import Input from 'components/fields/Input'
import type { App } from 'types/apps'

const Container = styled.div``

const Title = styled.h1`
	${({ theme }) => theme.typography.subHeading};
`

const Caption = styled.p`
	${({ theme }) => theme.typography.paragraph};
`

const StyledForm = styled(Form)`
	gap: 0;
	padding: 0;
`

const ButtonsRow = styled.div`
	display: flex;
	flex-direction: row;
	width: 100%;
	align-items: center;
	justify-content: flex-end;
	gap: ${({ theme }) => theme.spaces.space3};
	margin-top: ${({ theme }) => theme.spaces.space3};
`

type Props = {
	app: App
	onCancel: () => void
	onSubmit: (data: Props['app']['properties']) => Promise<void>
}

function AppPropertiesForm({ app, onSubmit, onCancel }: Props) {
	const { register, handleSubmit, formState } = useForm<typeof app.properties>({
		defaultValues: Object.fromEntries(Object.entries(app.properties).map(([key]) => [key, ''])),
	})

	return (
		<Container>
			<Title>Install app</Title>
			<Caption>
				Please provide the following information to add the <b>{app.name}</b> app to your widget.
			</Caption>
			<StyledForm onSubmit={handleSubmit(onSubmit)}>
				{Object.entries(app.properties).map(([name, label]) => (
					<Input required key={name} label={label} {...register(name, { required: true })} />
				))}
				<ButtonsRow>
					<Button disableHover type="button" kind="secondary" disabled={formState.isSubmitting} onClick={onCancel}>
						Cancel
					</Button>
					<Button disableHover type="submit" kind="primary" loading={formState.isSubmitting}>
						Install
					</Button>
				</ButtonsRow>
			</StyledForm>
		</Container>
	)
}

export default AppPropertiesForm
